import { render, staticRenderFns } from "./TagPromote.vue?vue&type=template&id=407426d8&scoped=true&"
import script from "./TagPromote.vue?vue&type=script&lang=js&"
export * from "./TagPromote.vue?vue&type=script&lang=js&"
import style0 from "./TagPromote.vue?vue&type=style&index=0&id=407426d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407426d8",
  null
  
)

export default component.exports